import createIcon from './createIcon';

const CooperationMailIcon = createIcon('CooperationMail', ({ color = 'currentColor', ...props }) => (
  <svg width={21} height={17} fill="none" {...props} viewBox="0 0 21 17" >
    <rect width="21" height="17" fill="none" />
    <path d="M2.10024 0L18.8998 0C20.0458 0 20.9854 0.943193 21 2.09904L10.5036 8.03591L0.00971196 2.10655C0.0194241 0.945695 0.951786 0 2.10024 0ZM0.00971214 4.37822L0 14.8759C0 16.0443 0.944502 17 2.10024 17L18.8998 17C20.0555 17 21 16.0443 21 14.8759L21 4.37322L10.7513 10.0324C10.5935 10.1199 10.4041 10.1199 10.2487 10.0324L0.00971122 4.37822L0.00971214 4.37822Z" fill={color} fillRule="nonzero" />
  </svg>
));

export { CooperationMailIcon }; 